import { useCallback } from "react"

export function useCategoryNavigation(
  breadcrumb,
  setBreadcrumb,
  setSelectedItems,
  categories,
  relations
) {
  const navigateInto = useCallback(
    (category) => {
      setBreadcrumb((prev) => [...prev, { id: category.id, name: category.name }])
      setSelectedItems([])
    },
    [setBreadcrumb, setSelectedItems]
  )

  const navigateTo = useCallback(
    (index) => {
      setBreadcrumb(breadcrumb.slice(0, index + 1))
      setSelectedItems([])
    },
    [breadcrumb, setBreadcrumb, setSelectedItems]
  )

  const jumpToCategory = useCallback(
    (category) => {
      const buildPath = (catId, path = []) => {
        const cat = categories.find((c) => c.id === catId)
        if (!cat) return path
        const parentRel = relations.find((r) => r.childId === catId)
        if (parentRel)
          return buildPath(parentRel.parentId, [{ id: cat.id, name: cat.name }, ...path])
        return [{ id: cat.id, name: cat.name }, ...path]
      }
      const path = buildPath(category.id)
      if (path.length > 0) setBreadcrumb(path)
    },
    [categories, relations, setBreadcrumb]
  )

  return { navigateInto, navigateTo, jumpToCategory }
}
